import LatestNewsBlock from "../common/blocks/LatestNewsBlock";
const News = () => {
	return (
	<div className="section-full latest-blog bg-gray p-t100 p-b70">
		{/* <!-- BLOG CONTENT START --> */}
		<LatestNewsBlock />
		{/* <!-- BLOG CONTENT END --> */}
	</div>
	);
};
export default News;